export default {
  getPlanUuidEditing: state => state.planUuidEditing,
  getPlanAlreadyFetchEditing: state => state.planAlreadyFetchEditing,
  getPlanName: state => state.planName,
  getPlanCommercialName: state => state.planCommercialName,
  getPlanCategoriesOptions: state => state.planCategoriesOptions,
  getPlanCategorySelected: state => state.planCategorySelected,
  getPlanPrice: state => state.planPrice,
  getPlanMovementsOptions: state => state.planMovementsOptions,
  getPlanMovementSelected: state => state.planMovementSelected,
  getPlanScore: state => state.planScore,
  getPlanPhysicalPerson: state => state.planPhysicalPerson,
  getPlanLegalPerson: state => state.planLegalPerson,
  getPlanActive: state => state.planActive,
  getPlanRecommended: state => state.planRecommended,
  getPlanShouldBeDisplayed: state => state.planShouldBeDisplayed,
  getPlanIcon: state => state.planIcon,
  getPlanIconPreview: state => state.planIconPreview,
  getPlanRelatedPackages: state => state.planRelatedPackages,
  getPlanCreatedThrough: state => state.planCreatedThrough,

  getPlanSvasOptions: state => state.planSvasOptions,
  getPlanSvasSelecteds: state => state.planSvasSelecteds,

  getPlanCampaignOptions: state => state.planCampaignOptions,
  getPlanCampaignSelecteds: state => state.planCampaignSelecteds,

  getPlanCoverageOptions: state => state.planCoverageOptions,
  getPlanCoverageStateOptions: state => state.planCoverageStateOptions,
  getPlanCoverageStatesSelecteds: state => state.planCoverageStatesSelecteds,

  getPlanCoverageCityStateOptions: state => state.planCoverageCityStateOptions,
  getPlanCoverageCityStateSelected: state =>
    state.planCoverageCityStateSelected,
  getPlanCoverageCityOptions: state => state.planCoverageCityOptions,
  getPlanCoverageCitySelecteds: state => state.planCoverageCitySelecteds,

  getPlanCoverageDddOptions: state => state.planCoverageDddOptions,
  getPlanCoverageDddSelecteds: state => state.planCoverageDddsSelecteds,

  getPlanAccessOptions: state => state.planAccessOptions,

  getPlanAccessChainOptions: state => state.planAccessChainOptions,
  getPlanAccessChainsSelecteds: state => state.planAccessChainsSelecteds,
  getPlanAccessPosOptions: state => state.planAccessPosOptions,
  getPlanAccessPosSelecteds: state => state.planAccessPosSelecteds,

  getPlanDiscountOptions: state => state.planDiscountOptions,
  getPlanDiscountTypes: state => state.planDiscountTypes,

  getPlanDiscountPaymentOptions: state => state.planDiscountPaymentOptions,
  getPlanDiscountPaymentSelecteds: state => state.planDiscountPaymentSelecteds,

  getPlanDiscountShippingOptions: state => state.planDiscountShippingOptions,
  getPlanDiscountShippingSelecteds: state => state.planDiscountShippingSelecteds,

  getHasAdditionalConfig: state => state.hasAdditionalConfig,
  getFreeAdditionalQuantity: state => state.freeAdditionalQuantity,
  getPaidAdditionalQuantity: state => state.paidAdditionalQuantity,
  getAdditionalUnitPrice: state => state.additionalUnitPrice
}
